import type { Event, EventStatus } from "../types";

export type EventJoinBlockCode =
  | "EVENT_NOT_STARTED"
  | "EVENT_PAUSED"
  | "EVENT_CLOSED"
  | "EVENT_COMPLETED"
  | "EVENT_CANCELLED"
  | "EVENT_UNAVAILABLE";

export type EventJoinBlock = {
  code: EventJoinBlockCode;
  eventName: string;
  startDate?: string;
};

export const getEventJoinBlock = (event: Pick<Event, "name" | "status" | "startDate">): EventJoinBlock | null => {
  const now = new Date();
  const start = new Date(event.startDate);

  if (now < start) {
    return {
      code: "EVENT_NOT_STARTED",
      eventName: event.name,
      startDate: event.startDate,
    };
  }

  const status = event.status as EventStatus;

  if (status === "PAUSED") {
    return { code: "EVENT_PAUSED", eventName: event.name };
  }
  if (status === "CLOSED") {
    return { code: "EVENT_CLOSED", eventName: event.name };
  }
  if (status === "COMPLETED") {
    return { code: "EVENT_COMPLETED", eventName: event.name };
  }
  if (status === "CANCELLED") {
    return { code: "EVENT_CANCELLED", eventName: event.name };
  }
  if (status !== "ACTIVE" && status !== "UPCOMING") {
    return { code: "EVENT_UNAVAILABLE", eventName: event.name };
  }

  return null;
};
